var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',[_c('defs',[_c('clipPath',{attrs:{"id":"myClip"}},[(_vm.shapes.length > 0)?_c('polygon',{attrs:{"points":_vm.getShapesPath(_vm.shapes),"fill":"#0f09","stroke":"black"}}):_c('polygon',{attrs:{"points":`0 0,${(_vm.sliderVal / 100) * _vm.imgDims.width} 0,${
          (_vm.sliderVal / 100) * _vm.imgDims.width
        } ${_vm.imgDims.height},0 ${_vm.imgDims.height},0 0`}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }